import styled from 'styled-components'

export const Page = styled.main`
    width: 100%;
    max-width: 1560px;
    margin: 0 auto;
    padding: 124px clamp(18px, 2.4vw, 36px) 72px;
`;
